import { ThunkType } from "../../../../core/store/reducers";
import { getDisputeReport } from "../api/getDisputeReport";
import fileDownload from "js-file-download";
import { setFetchState } from "../disputeDataSlice";

export const downloadDisputeReport = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.clearing.disputes;
  const user = store.data.auth.current.user;

  dispatch(setFetchState({ type: "started" }));
  const ordersReport = await dispatch(getDisputeReport(user, filter));
  if (ordersReport) {
    fileDownload(
      new Blob([ordersReport as any], { type: "application/pdf" }),
      "Dispute.pdf"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};

